var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"},on:{"click":_vm.onClick}},[_c('Card',{staticClass:"card"},[_c('img',{attrs:{"src":require(("@/assets/icons/" + _vm.icon))}}),_c('div',[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }